import { Component, Input } from '@angular/core';
import { DictionaryRequestStatus } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'contract-modifications-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss'],
  standalone: false,
})
export class ContractModificationsCardViewComponent {
  public dictionaryRequestStatus = DictionaryRequestStatus;

  @Input() reimbursementType: app.models.DictionaryDataModel;

  @Input() contractModifications: app.models.ContractModificationRequest[];
  @Input() props: app.models.DynamicPropsDictionary;
  @Input() viewDetails: any;
}
